module.exports = __webpack_public_path__ + "static/media/placeholder_car.fcab19be.svg";